module.exports = __webpack_public_path__ + "img/finish.b4cf5270.png";